// extracted by mini-css-extract-plugin
module.exports = {"slider":"kM","lightBg":"kN","sliderLink":"kO","sliderTitle":"kP","sliderTitleSelected":"kQ","centerMenu":"kR"};